/**
 * @param {?} el
 * @param {?} parentSelector
 * @return {?}
 */
export function getParents(el, parentSelector) {
    // If no parentSelector defined will bubble up all the way to *document*
    if (parentSelector === undefined) {
        parentSelector = 'body';
    }
    var /** @type {?} */ parents = [];
    var /** @type {?} */ p = el.parentNode;
    var /** @type {?} */ pxz = null;
    while (!pxz) {
        var /** @type {?} */ o = p;
        parents.push(o);
        p = o.parentNode;
        pxz = p.querySelector(parentSelector);
    }
    // parents.push(_parentSelector); // Push that parentSelector you wanted to stop at
    // console.log(parents[parents.length - 1]);
    return parents[parents.length - 1];
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/core/parents.js
// module id = 1355
// module chunks = 31